import { render, staticRenderFns } from "./DummyContentUploader.vue?vue&type=template&id=36c424e2&"
import script from "./DummyContentUploader.vue?vue&type=script&lang=js&"
export * from "./DummyContentUploader.vue?vue&type=script&lang=js&"
import style0 from "./DummyContentUploader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports